import React from 'react'

function Inventer() {
  return (
    <div>Inventer</div>
  )
}

export default Inventer